import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

interface PracticePdf {
  lang: string;
  flag: string;
  file: string;
  thumb: string;
}

@Component({
  selector: 'app-good-practices',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './good-practices.component.html',
  styleUrl: './good-practices.component.css',
})
export class GoodPracticesComponent {
  pdfs: PracticePdf[] = [
    { lang: 'Español', flag: '🇪🇸', file: 'assets/docs/buenas-practicas-es.pdf', thumb: 'assets/images/placeholders/buenas-practicas-es.png' },
    { lang: 'English', flag: '🇬🇧', file: 'assets/docs/buenas-practicas-en.pdf', thumb: 'assets/images/placeholders/buenas-practicas-en.png' },
    { lang: 'Deutsch', flag: '🇩🇪', file: 'assets/docs/buenas-practicas-de.pdf', thumb: 'assets/images/placeholders/buenas-practicas-de.png' },
    { lang: 'Français', flag: '🇫🇷', file: 'assets/docs/buenas-practicas-fr.pdf', thumb: 'assets/images/placeholders/buenas-practicas-fr.png' },
  ];
}
